/**
 * Sterne für erledigte Aufgaben (26.10.2026) — für Kinder, die mit Geld noch
 * nichts anfangen können. „10 Sterne = Eis“: Die Eltern legen eine Belohnung
 * fest und lösen sie ein, wenn genug Sterne da sind.
 *
 * Sterne sind **kein Geld** und stehen nie in `pocket_money` — eine Summe,
 * die Sterne als Cent zählt, wäre falsch, ohne dass es jemand merkt. Wie beim
 * Taschengeld stehen sie als Zeilen da, nie als Zähler.
 */
import { stableId } from './ids.js';

/**
 * `task` bucht der Server für eine erledigte Aufgabe mit Sternen, `bonus`
 * vergeben Erwachsene von Hand, `redeem` lösen Erwachsene für die Belohnung
 * ein. Kinder schreiben keine Sterne.
 */
export const STAR_KINDS = ['task', 'bonus', 'redeem'] as const;
export type StarKind = (typeof STAR_KINDS)[number];

/** Was nur der Server bucht. */
export const SERVER_STAR_KINDS = ['task'] as const;

/** Höchstens so viele Sterne je Aufgabe oder Buchung. */
export const MAX_REWARD_STARS = 5;
export const MAX_STAR_ENTRY = 100;
/** Größte Belohnung — ein Ziel, das nie erreicht wird, entmutigt. */
export const MAX_STAR_GOAL = 50;
export const STAR_GOAL_NAME_MAX = 60;

interface StarRow {
  kind: string;
  stars: number;
  deletedAt?: string | null;
}

/** Stand: Aufgaben und Extra plus, Eingelöstes minus. */
export function starBalance(entries: readonly StarRow[]): number {
  let stars = 0;
  for (const entry of entries) {
    if (entry.deletedAt) continue;
    stars += (entry.kind === 'redeem' ? -1 : 1) * entry.stars;
  }
  return stars;
}

/**
 * Feste Kennung der Sterne für eine erledigte Aufgabe: je Aufgabe und Tag
 * genau eine Buchung — wie `rewardEntryId`, aber ein eigener Schlüssel, damit
 * Geld und Sterne für dieselbe Aufgabe nie dieselbe Zeile treffen.
 */
export function starEntryId(taskId: string, doneDate: string): string {
  return stableId(`stars:${taskId}:${doneDate}`);
}
